import React, { Component } from 'react';
import logo from './img/dflogo.png';
import './App.css';
import Main from './components/Main.js';
import SalesConfirm from './components/SalesConfirm'
import queryString from 'query-string';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
);

const isDev = Boolean(
	window.location.hostname.indexOf("-dev.") > 0 ||
	window.location.hostname.indexOf("-test.") > 0
);

const targetUrl = isLocalhost ? "https://fleetbase-double-opt-in-test-fa.azurewebsites.net/api/" : (isDev ? "https://fleetbase-double-opt-in-test-fa.azurewebsites.net/api/" : "https://fleetbase-double-opt-in-fa.azurewebsites.net/api/");

const urlParams = queryString.parse(window.location.search);
const confirmation = urlParams.confirmation;
const token = urlParams.token || urlParams.sub || urlParams.confirm;
const req = urlParams.e;

class App extends Component {
  render() {
    const componentMain = confirmation ? (
      <SalesConfirm token={confirmation} targetUrl={targetUrl} />
    ) : (
      <Main token={token} req={req} targetUrl={targetUrl} />
    );

    return (
      <div className="App">
        <header className="App-header">
          <div>
            <a href="https://www.dataforce.de/">
              <img src={logo} style={{ height : 40 }} alt="Dataforce Verlagsgesellschaft für Business Informationen mbH" />
            </a>
          </div>
        </header>
        <div className="App-Main">
          {componentMain}
        </div>
        <div className="App-footer">
          <ul className="ulfoot">
            <li><a href="https://www.dataforce.de/impressum/">Impressum</a></li>
            <li><a href="https://www.dataforce.de/kontakt/">Kontakt</a></li>
          </ul>
        </div>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js